/**
 * dayjs plugin registration. **Imported for its side effect** — it exports nothing, and
 * `import dayjs from "dayjs"` is still how every other file gets the library.
 *
 * It is a module rather than a block in `main.tsx` for an ordering reason as well as a
 * tidiness one. ES imports are evaluated before the importing module's own statements, so
 * as top-level code in `main.tsx` these `extend` calls ran *after* every route file and
 * component had already been loaded. Nothing depended on a plugin at module scope, so it
 * worked — but only by accident. Imported first in `main.tsx`, the plugins are registered
 * before any other module is evaluated, which is the guarantee the call sites assume.
 *
 * `package.json` declares no `sideEffects` field, so Rollup treats this module as impure
 * and will not tree-shake the bare import away.
 */

import dayjs from "dayjs";
import CustomParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import UpdateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(CustomParseFormat);
dayjs.extend(UpdateLocale);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(LocalizedFormat);
